import type { MarkerMapObject } from "../types";

export interface MarkerRaw {
    id: string | number;
    x: string | number;
    y: string | number;
    z?: string | number;
    yaw?: string | number;
    width?: string | number;
    height?: string | number;
    valid?: boolean | 0 | 1 | "0" | "1";
    [key: string]: unknown;
}

const parseNumber = (value: unknown, fallback = 0): number => {
    const parsed = Number.parseFloat(String(value));
    return Number.isFinite(parsed) ? parsed : fallback;
};

const parseBoolean = (value: unknown): boolean =>
    value === true || value === 1 || value === "1";

export function parseMarkers(
    markers: MarkerRaw[] | null | undefined,
): MarkerMapObject[] {
    if (!Array.isArray(markers)) return [];

    return markers.map((marker) => {
        const x = parseNumber(marker.x);
        const y = parseNumber(marker.y);
        const z = parseNumber(marker.z);
        const yaw = parseNumber(marker.yaw);
        const width = parseNumber(marker.width) / 1000;
        const height = parseNumber(marker.height) / 1000;

        return {
            id: String(marker.id),
            type: "marker",
            label: String(marker.id),
            valid: parseBoolean(marker.valid),
            x: x,
            y: y,
            z: z,
            yaw: yaw,
            width: width,
            height: height,
            interactive: true,
        };
    });
}
